import styles from "../../styles/SchoolEnquiry/confirmation-schoolai.module.css";
import ConfirmSvg from '../../assets/ai-assistant/Group.svg';


export default function ConfirmationPageSchoolAi({ onClose }) {


    return (
        <div className={styles.container}>

            <img src={ConfirmSvg} />
            <div className={styles.boldText}>
                <div>Thank you for submitting the form.</div>
                <div className={styles.normalText}>Our AI expert team will reach out to you soon.</div>
            </div>
            <div className={styles.button} onClick={onClose}>
                Done
            </div>
        </div>
    )
}
